import { Tag } from "antd"
import { FC, PropsWithChildren } from "react"

type PropType = FC<PropsWithChildren<{
  text: string
}>>

const getTagColor = (text) => {
  switch(text) {
    case '待重新记账':
      return '#f50';
    case '已记账':
      return '#87d068'
    case '待记账':
      return '#FA8C16'
    case '未分配':
      return '#1677FF';
    default:
      return '#c4c2c2'
  }
}

const Component: PropType = ({text}) => {
  return text && <Tag color={getTagColor(text)}>{text}</Tag>
}

export default Component
